<template>
  <div>
    <h1 class="m-h-30" v-if="$user.$$is_super || $user.$$is_channel">欢迎使用{{$app_name}}！</h1>
    <div v-else>
      <AdminCollectionList class="m-b-10" v-if="$user.$$auth.admin_plan">
        <h3 class="m-v-0" slot="title">文件收集情况</h3>
      </AdminCollectionList>
      <div class="empty-block m-b-10" v-else>
        <div class="empty-text">你没有开通文件收集权限，请联系您的系统管理员进行开通</div>
      </div>
      <FileCenter class="m-b-10 min-height-300" admin v-if="$user.$$auth.department_file">
        <h3 class="m-v-0" slot="title">部门文件共享</h3>
      </FileCenter>
      <div class="empty-block m-b-10" v-else>
        <div class="empty-text">你没有开通文件共享权限，请联系您的系统管理员进行开通</div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminCollectionList from 'components/collection/AdminCollectionList.vue'
import FileCenter from 'components/file/FileCenter.vue'

export default {
  components: {AdminCollectionList, FileCenter},
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/Dashboard.vue